/** Maps `/get-all-professional-guardians` rows for Bond Retrieval guardian Autocomplete options. */

/** @param {object} guardian */
function resolvePgDisplayAddress(guardian) {
  return guardian.mailing_address === ", , ,"
    ? guardian.physical_address
    : guardian.mailing_address;
}

/** Shared shape for VA, Trustee, and Probate autocomplete options ({ value, label, address, cell }). */
function mapProfessionalGuardianAddressOption(guardian) {
  return {
    value: guardian.pg_id,
    label: guardian.full_name,
    address: resolvePgDisplayAddress(guardian),
    cell: guardian.cell_phone,
  };
}

export const mapProfessionalGuardianVA = mapProfessionalGuardianAddressOption;
export const mapProfessionalGuardianTrustee = mapProfessionalGuardianAddressOption;

export function mapProfessionalGuardianGuardianship(guardian) {
  return {
    value: guardian.pg_id,
    label: guardian.full_name,
    guardian_street_address_1: resolvePgDisplayAddress(guardian),
    guardian_city: guardian.city,
    guardian_state: guardian.state,
    guardian_zip: guardian.zip_code,
    cell: guardian.cell_phone,
  };
}

export const mapProfessionalGuardianProbate = mapProfessionalGuardianAddressOption;
